import template from './publicationPitch.html';

function PublicationPitchController($q, Publication, siteService) {
  const $ctrl = this;
  const PUBS_PER_PAGE = 20;

  $ctrl.getPublications = () => {
    const params = {
      page: $ctrl.currentPage,
      size: PUBS_PER_PAGE
    };

    if ($ctrl.siteFilter) {
      params.website = $ctrl.selectedWebsite;
    } else {
      params.set = $ctrl.set;
    }

    Publication.getPublicationsList(params).then(({ publications = null }) => {
      if (publications) {
        $ctrl.determineUnpitched(publications);
        $ctrl.pubsAvailable = true;
      }
    }).catch(() => {
      $ctrl.pubsAvailable = false;
    });
  };

  $ctrl.fetchNextPage = () => {
    $ctrl.pubsAvailable = false;
    $ctrl.currentPage += 1;
    $ctrl.getPublications();
  };

  $ctrl.determineUnpitched = (publications) => {
    if (!Array.isArray(publications)) {
      return; // EXIT
    }

    const unpitched = publications.filter(publication =>
      !$ctrl.excludedIds.includes(publication.id)
    );

    $ctrl.formPublications = unpitched.splice(0, PUBS_PER_PAGE);
    if ($ctrl.selectedPublications && $ctrl.selectedPublications.length > 0) {
      $ctrl.formPublications.forEach((pub, i) => {
        const existingPub = $ctrl.selectedPublications.find(selectedPub =>
          pub.id === selectedPub.id
        );
        if (existingPub) {
          $ctrl.formPublications[i].active = true;
        }
      });
    }

    if (!$ctrl.formPublications.length && ($ctrl.numPages - 1) > $ctrl.currentPage) {
      $ctrl.fetchNextPage();
    }
  };

  $ctrl.updatePublications = (id, name, website, active) => {
    const isPublicationInView = $ctrl.formPublications.findIndex(pub => pub.id === id);
    if (isPublicationInView >= 0) {
      $ctrl.formPublications[isPublicationInView].active = active;
    } else {
      $ctrl.formPublications.push({ active, name, id });
    }

    $ctrl.toggleOneTarget({
      target: {
        id,
        publicationName: name,
        website
      }
    });
  };

  $ctrl.change = (targetChange) => {
    $ctrl.updateTarget({ change: targetChange });
  };

  $ctrl.$onInit = async () => {
    $ctrl.note = {};
    $ctrl.set = null;
    $ctrl.siteFilter = true;
    $ctrl.formData.canHoldUntil = null;
    const selected = siteService.getSelectedWebsite();

    if (selected) {
      $ctrl.selectedWebsite = selected._id;
    } else {
      const defaultSite = await siteService.getDefaultWebsite();
      $ctrl.selectedWebsite = defaultSite._id;
    }

    $ctrl.pubsAvailable = false;

    try {
      const [count, sets] = await $q.all(
        [
          Publication.getNumberOfPublications(),
          Publication.getSets()
        ]
      );

      $ctrl.numPages = count ? Math.ceil(count / PUBS_PER_PAGE) : 0;
      $ctrl.currentPage = 0;
      $ctrl.sets = sets;

      $ctrl.getPublications();
    } catch (error) {
      $ctrl.pubsAvailable = false;
    }
  };

  $ctrl.$onChanges = ({ excludedIds = null }) => {
    if (excludedIds && Array.isArray(excludedIds.currentValue) && $ctrl.formPublications) {
      $ctrl.determineUnpitched($ctrl.formPublications);
    }
  };

  $ctrl.updateFilter = () => {
    $ctrl.currentPage = 0;
    $ctrl.getPublications();
  };

  $ctrl.toggleFilter = () => {
    $ctrl.siteFilter = !$ctrl.siteFilter;
    $ctrl.currentPage = 0;
    $ctrl.getPublications();
  };
}

const publicationPitch = {
  template,
  bindings: {
    excludedIds: '<',
    formData: '<',
    toggleOneTarget: '&',
    updateTarget: '&',
    sites: '<',
    selectedPublications: '<'
  },
  controller: 'PublicationPitchController'
};

const controllerArray = [
  '$q',
  'Publication',
  'siteService',
  PublicationPitchController
];

export default function (ngModule) {
  ngModule.component('publicationPitch', publicationPitch);
  ngModule.controller('PublicationPitchController', controllerArray);
}
